import { lazy, type LazyExoticComponent } from 'react';

import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const GoogleCalendarEventCreateRendererAsync: LazyExoticComponent<
	(props: ActionRendererFor<typeof ActionKeys.GoogleCalendarEventCreate>) => React.JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/google-calendar-event-create" */ './index'
	).then((m) => ({ default: m.GoogleCalendarEventCreateAction })),
);
